import { render, staticRenderFns } from "./addEventForm.vue?vue&type=template&id=d875592c&"
import script from "./addEventForm.vue?vue&type=script&lang=js&"
export * from "./addEventForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports